import {Fragment} from "preact";
import {usePopUpAlert} from "./usePopUpAlert";
import {Dialog, Transition} from "@headlessui/react";
import Content from "./Content";

const PopUpAlert = (props) => {
    // Destructured props
    const {rawPathName} = props;

    // Component logic data
    const componentProps = usePopUpAlert({
        rawPathName
    });

    // Destructured component logic data
    const {
        isOpen,
        setIsOpen,
        data
    } = componentProps;

    // Error prevention clause
    if (
        !data ||
        Object.keys(data).length === 0
    ) {
        return null;
    }

    return (
        <Fragment>
            <Transition.Root show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-[20]" onClose={setIsOpen}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-75 transition-opacity" />
                    </Transition.Child>
                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full px-4 md:px-0 items-center justify-center text-center sm:items-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-700"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-300"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className={`relative transform text-left duration-700 sm:max-w-[362px] w-screen flex items-start md:items-center`}>
                                    <Content
                                        setIsOpen={setIsOpen}
                                        data={data}
                                    />
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </Fragment>
    )
}

export default PopUpAlert;
